import { ApiService } from "@/api";

export const updateRejectSampleAttachment = (form: File) => {
  return ApiService.baseAction(
    `rejected-sample/attachment`,
    {
      data: form
    },
    "post"
  );
};
